import { AutoUser } from './auto-user';
import { CoordinatorService } from './coordinator.service';
import { ProjectMember } from './project-member';
import { ScriptUser } from './script-user';

export class ScriptUserManager {
    #coords: CoordinatorService;

    private _current?: ScriptUser;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    get current() {
        if (!this._current) {
            const t = this.#coords.project$.current?.team;
            if (t) {
                for (const pm of t.memberLs) {
                    if (pm.isCurrentUser) {
                        this._current = pm.scriptClass;
                        break;
                    }
                }
            } else {
                this._current = new ScriptUser(this.#coords);
            }
        }
        return this._current!;
    }

    list() {
        const t = this.#coords.project$.current?.team;
        if (t) {
            return t.memberLs.map((pm) => pm.scriptClass);
        } else {
            return [new ScriptUser(this.#coords)];
        }
        // return this.#coords.autouser$.autouserLs.map((au) => new ScriptAutoUser(this.#coords, au));
    }

    get currentAutouserSnapshot() {
        console.log('[EXPORT DEBUG] Creating currentAutouserSnapshot');
        const au = new AutoUser(this.#coords, {
            isCurrentSnapshot: true,
            name: this.#coords.text('Exporter'),
        }).scriptClass;
        console.log('[EXPORT DEBUG] currentAutouserSnapshot created:', {
            id: au.id,
            name: au.name
        });
        return au;
    }

    othersAsAutouserList() {
        console.log('[EXPORT DEBUG] othersAsAutouserList() called');
        const fullList = this.list();
        console.log('[EXPORT DEBUG] Full user list count:', fullList.length);
        
        const filtered = fullList.filter((su) => !su.isCurrent && !su.isLocalUser);
        console.log('[EXPORT DEBUG] After filtering (non-current, non-local):', filtered.length);
        
        const result = filtered.map((x) => {
            console.log('[EXPORT DEBUG] Creating autouser for:', x.name, 'isCurrent:', x.isCurrent);
            return x.autouser();
        });
        
        console.log('[EXPORT DEBUG] othersAsAutouserList result count:', result.length);
        return result;
    }

    get(nm: string) {
        if (nm === '_localUser') return this.current;
        for (const su of this.list()) {
            if (su.id === nm) return su;
        }
        nm = this.#coords.utils$.normalizeString(nm);
        for (const su of this.list()) {
            if (this.#coords.utils$.normalizeString(su.name) === nm) return su;
        }
        return null;
    }

    log(prefix = 'User Manager') {
        console.log(prefix);
        console.log(this.list());
    }

    display(prefix = 'User Manager') {
        console.log(prefix, this);
    }
}
